import React, { useState, useEffect } from 'react';
import { DropMenu, Icon } from '@roo/roo';
import { Link, useLocation } from 'react-router-dom';
import h2 from '@assets/images/header_left_2a.png';
import h1 from '@assets/images/header_left_1.png';
import { removeLeaveTip } from '@utils/utils';
import { UserAction } from './UserAction';
import { useUserContext } from '../UserData';

import './header.scss';

const pathPrefix = window.location.pathname.includes('/v2') ? '/v2' : '';

const QingshanMenu = [
  {
    label: '简介',
    href: `${pathPrefix}/award/intro`,
    target: '_self',
  },
  {
    label: '章程',
    href: `${pathPrefix}/award/regulation`,
    target: '_self',
  },
  {
    label: '申报指南',
    href: `${pathPrefix}/award/application`,
    target: '_self',
  },
  {
    label: '常见问题',
    href: `${pathPrefix}/award/question-answer`,
    target: '_self',
  },
  {
    label: '历届获奖人',
    href: `${pathPrefix}/award/laureates`,
    target: '_self',
  },
];

const kechuangMenu = [
  {
    label: '简介',
    href: `${pathPrefix}/environment/intro`,
    target: '_self',
  },
  {
    label: '章程',
    href: `${pathPrefix}/environment/regulation`,
    target: '_self',
  },
  {
    label: '历届获奖项目',
    href: `${pathPrefix}/environment/laureates`,
    target: '_self',
  },
];

const Header = (
  { renderUserAction },
) => {
  const { pathname } = useLocation();
  const [opacity, setOpacity] = useState(1);
  const { update } = useUserContext((t) => [t.frameUrl]);

  const changeOpacity = () => {
    const scrollPercent = (document.body.scrollTop + document.documentElement.scrollTop) / 115;
    setOpacity(scrollPercent < 1 && (pathname === '/' || pathname === '/v2') ? scrollPercent : 1);
  };

  useEffect(() => {
    changeOpacity();
    removeLeaveTip();
    window.addEventListener('scroll', changeOpacity);
    return () => {
      window.removeEventListener('scroll', changeOpacity);
    };
  }, [pathname]);

  return (
    <div className="home-header" style={{ backgroundColor: `rgba(255,255,255,${opacity})`, height: 80 }}>
      <div className="h-icon" style={{ height: 80 }}>
        <img src={h1} style={{ marginTop: 25, marginRight: 14 }} />
        <img src={h2} style={{ marginTop: 25 }} />
      </div>
      <div className="h-links">
        <div>
          <Link to={`${pathPrefix}`}>首页</Link>
        </div>
        <div>
          <Link
            className={pathname === `${pathPrefix}/trend` || pathname === `${pathPrefix}/new` ? 'active' : ''}
            to={`${pathPrefix}/trend`}
            onClick={() => {
              update((t) => (t.frameUrl = ''));
            }}
          >
            基金动态
          </Link>
        </div>
        <div>
          <DropMenu className="menu-drop" menu={QingshanMenu} popupWrapClassName="wrap-pop">
            <div className={pathname.includes('/award') ? 'active menu-item' : 'none  menu-item'}>
              青山科技奖
              <Icon name="chevron-down" />
            </div>
          </DropMenu>
        </div>
        <div>
          <DropMenu className="menu-drop" menu={kechuangMenu} popupWrapClassName="wrap-pop">
            <div className={pathname.includes('/environment') ? 'active menu-item' : 'none  menu-item'}>
              "科创中国"美团青山环保科技创新示范项目
              <Icon name="chevron-down" />
            </div>
          </DropMenu>
        </div>
      </div>
      <div className="action-wrap">
        {
          renderUserAction ? renderUserAction()
            : <UserAction />
        }
      </div>
    </div>
  );
};

export default Header;
